module.exports = __webpack_public_path__ + "img/icon_sm_ysdcx.a9499323.png";